<div
  id="home-master-div"
  :class="{ 'fixed-height': showMapNavigation }"
  :style="{ background: 'white', color: '#424242' }"
>
  <div
    :ref="el => el && registerElement(el, SIDE_BAR)"
    class="sidebar-sticky-wrapper"
  >
    <SideBar
      :name="user && user.name"
      :email="user && user.email"
      :showChatBot="showChatBot"
      :anyOtherModalOpen="anyOtherModalOpen"
      :disable-payment-methods="showDemonstration"
      @priceTable="scrollToPriceTable"
      @openChat="toggleChatBot"
    />
  </div>

  <div
    v-if="ENABLE_CHATBOT"
    :class="{ 'below-overlay': anyOtherModalOpen && !showChatBot }"
  >
    <div
      v-if="user && showChatBot"
      class="chatbot-backdrop"
      @click="toggleChatBot"
    ></div>

    <div
      v-if="user && showChatBot"
      class="chatbot-fixed"
      @click.stop
    >
      <ChatBot
        :cableType="cableType ? String(cableType) : null"
        :transactionId="transactionId"
        :userToken="token"
        :pointName="pointName"
        :userPosition="position"
        :signature="signature"
        :user="user"
        :pixPayed="pixPayed"
        :lastTransactionState="lastTransactionStatus"
      />
    </div>
  </div>

  <div
    class="d-flex justify-content-center"
    v-if="!user"
  >
    <b-spinner class="loading-spinner mt-5" />
  </div>

  <!-- Fluxo Normal -->
  <div
    v-else
    class="default-container"
  >
    <!-- Mapa + GPS + Active Rental Hub (Unificado) -->
    <MapNavigation
      ref="mapNavigationRef"
      :initial-token="qrTokenFromScan"
      :cable-type="cableType"
      :user="user"
      :mode="lastTransactionStatus === TAKE_BATTERY_SUCCESS ? 'return' : 'withdrawal'"
      :has-rented-battery="lastTransactionStatus === TAKE_BATTERY_SUCCESS || (lastTransaction && ['validation_error', 'take_battery_error', 'firmware_communication_error', 'timeouted', 'canceled_by_customer'].includes(lastTransaction.status))"
      :last-transaction="lastTransaction"
      :campaign="campaign"
      :show-close-button="false"
      v-show="(showMapNavigation || lastTransactionStatus === TAKE_BATTERY_SUCCESS) && !showLastTransactionInfo && !showRatingTransaction"
      @close="toggleMapNavigation"
      @withdraw-battery="handleMapWithdrawBattery"
      @start-rental="handleMapStartRental"
      @check-prices="handleMapCheckPrices"
      @change-cable-type="handleChangeCableType"
      @start-manual-checkout="handleStartManualCheckout"
      @modal-state-change="isMapModalOpen = $event"
      @update-location="position = $event"
    />

    <!-- Outros Componentes (Ocultos se o mapa ou aluguel ativo estiverem visíveis) -->
    <div
      v-if="!showMapNavigation && lastTransactionStatus !== TAKE_BATTERY_SUCCESS && !showErrorModal"
      class="default-container-start"
    >
      <div
        v-if="lastTransaction && showLastTransactionInfo"
        :ref="el => el && registerElement(el, LAST_TRANSACTION_INFO)"
      >
        <TransactionInfo
          :result="lastTransaction"
          :showTransactionRating="false"
          @confirmAction="handleCloseLastTransactionInfo"
        />
      </div>

      <div
        v-if="lastTransaction && showRatingTransaction"
        :ref="el => el && registerElement(el, RATING_TRANSACTION)"
      >
        <RatingTransaction
          :pointName="lastTransaction.return_point ? lastTransaction.return_point.name : ''"
          :token="lastTransaction.token"
          :transactionId="lastTransaction.id"
          @confirmAction="handleShowRatingTransaction"
        />
      </div>

      <div
        v-if="showDemonstration && !isDemonstrationLocked"
        :ref="el => el && registerElement(el, TAKE_DEMONSTRATION)"
      >
        <TakeDemonstration
          :totalSlots="totalSlots"
          :selectedSlot="selectedSlot"
        />
      </div>

      <div
        v-if="showPriceTable"
        :ref="el => el && registerElement(el, PRICE_TABLE)"
      >
        <PriceTable
          class="select-card margin-important"
          :showPriceTable="showPriceTable"
          :pointId="pointId"
          :allowEdit="true"
          @close="scrollToPriceTable"
          @handleTokenSelection="showPriceTable = false"
        />
      </div>
    </div>
  </div>

  <!-- Modais de Overlay -->
  <!-- Modal de Avaliação / Falha na Retirada (Take Battery Error / Timeout) -->
  <transition name="fade">
    <div
      v-if="showEvaluationTags && transactionId"
      :ref="el => el && registerElement(el, FAILED_DIALOG)"
    >
      <FailedDialog
        :transaction-id="transactionId"
        :cable-type="cableType"
        :token="token"
        :payment-method="paymentMethod"
        :transaction-timestamp="transactionTimestamp"
        @try-again="handleRetrySuccess"
        @refund-success="handleRefundSuccess"
      />
    </div>
  </transition>

  <!-- Modal de Reembolso Agendado / Realizado (Pix e Cartão) -->
  <transition name="fade">
    <RefundSuccessModal
      v-if="showRefundSuccessModal"
      :is-scheduled="isRefundScheduledState"
      :is-automatic="isAutomaticRefund"
      :payment-method="refundPaymentMethod"
      :transaction-id="refundedTransactionId"
      :amount="refundAmount"
      @close="handleCloseRefundSuccessModal"
    />
  </transition>

  <div
    v-if="showPriceTableModal"
    class="price-table-modal-backdrop"
    @click="closePriceTableModal"
  >
    <div
      class="price-table-modal-content"
      @click.stop
    >
      <div class="price-table-modal">
        <PriceTable
          :showPriceTable="showPriceTableModal"
          :pointId="pointIdModal"
          :allowEdit="true"
          :externalPage="true"
          @close="closePriceTableModal"
          @handleTokenSelection="closePriceTableModal"
        />
      </div>
    </div>
  </div>

  <b-modal
    v-model="showErrorModal"
    :title="errorTitleModal"
    hide-footer
    centered
    no-stacking
  >
    <div class="text-center p-3">
      <font-awesome-icon
        icon="fa-solid fa-triangle-exclamation"
        class="text-warning mb-3 error-modal-icon"
      />
      <p class="mb-4">{{ errorMessageModal }}</p>
      <BaseButton
        variant="primary"
        unstyled
        class="w-100 font-weight-bold error-modal-confirm-button"
        @click="handleErrorModalConfirm"
      >
        {{ $t('home.take.understand') }}
      </BaseButton>
    </div>
  </b-modal>

  <!-- Payment Method Selector Overlay (manual token flow) -->
  <transition name="fade">
    <div
      v-if="showPaymentSelectorModal"
      class="payment-selector-overlay"
      @click="showPaymentSelectorModal = false"
    >
      <div
        class="payment-selector-modal"
        @click.stop
      >
        <div class="selector-header">
          <h5>{{ $t('map_navigation.payment_verification') }}</h5>
          <ModalCloseButton @close="showPaymentSelectorModal = false" />
        </div>
        <div class="selector-body">
          <PaymentMethodSelector
            :user="user"
            :disable-delete="lastTransactionStatus === TAKE_BATTERY_SUCCESS"
            :disable-change="showDemonstration"
            @payment-method-added="handlePaymentMethodModalAdded"
          />
        </div>
      </div>
    </div>
  </transition>
</div>
